import { render, staticRenderFns } from "./createCardClass.vue?vue&type=template&id=2fafa01c&scoped=true&"
import script from "./createCardClass.vue?vue&type=script&lang=js&"
export * from "./createCardClass.vue?vue&type=script&lang=js&"
import style0 from "./createCardClass.vue?vue&type=style&index=0&id=2fafa01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fafa01c",
  null
  
)

export default component.exports